export const formatMedicareNumber = (medicare: string, referenceId: string) => {
  console.log('D> medicare, referenceId', medicare, referenceId);
  
  if (!medicare && !referenceId) return '-';

  if (medicare?.length === 11 && (referenceId?.length < 1 || !referenceId)) {
    return `${medicare.slice(0, 10)}-${medicare[10]}`;
  }

  return `${medicare}-${referenceId}`;
};